var map = {
	"./charity-1.webp": 62337,
	"./charity-10.webp": 8669,
	"./charity-11.webp": 84670,
	"./charity-12.webp": 57168,
	"./charity-13.webp": 65219,
	"./charity-14.webp": 58519,
	"./charity-15.webp": 10620,
	"./charity-16.webp": 91427,
	"./charity-17.webp": 19528,
	"./charity-18.webp": 71081,
	"./charity-19.webp": 29835,
	"./charity-2.webp": 85320,
	"./charity-20.webp": 82806,
	"./charity-21.webp": 19055,
	"./charity-22.webp": 41374,
	"./charity-23.webp": 70034,
	"./charity-24.webp": 70013,
	"./charity-3.webp": 46153,
	"./charity-4.webp": 28209,
	"./charity-5.webp": 98986,
	"./charity-6.webp": 70118,
	"./charity-7.webp": 86268,
	"./charity-8.webp": 70778,
	"./charity-9.webp": 77052
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31439;